import { useCallback, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LINE_ITEM_TYPE_ID, PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Button } from 'foundations-components/transitional/components/Button';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { getEffectiveTieredPriceCurrencyCode } from '../../utils/currency';
import { useAdditionalPropertyValues } from '../../v2/hooks/useAdditionalPropertyValues';
import { useHomeCurrency } from '../../v2/hooks/useHomeCurrency';
import { useObjectTypeId } from '../../v2/hooks/useObjectTypeId';
import { useProperty } from '../../v2/hooks/useProperty';
import { TieredPriceModal } from './TieredPriceModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormattedPropertyTieredPrice = () => {
  useComponentMountMetric('FormattedPropertyTieredPrice');
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    lineItemCurrencyCode: 'hs_line_item_currency_code',
    pricingModel: 'hs_pricing_model',
    tiersPrices: 'hs_tier_prices',
    tiersRanges: 'hs_tier_ranges'
  });
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const [showTiersModal, setShowTiersModal] = useState(false);
  const showViewTiersModal = useCallback(() => {
    setShowTiersModal(true);
  }, []);
  const onClose = useCallback(() => {
    setShowTiersModal(false);
  }, []);
  const onSave = useCallback(() => {
    // TODO: maybe call onChange function here for line item quantity updating
    setShowTiersModal(false);
  }, []);
  const effectiveCurrencyCode = useMemo(() => {
    return getEffectiveTieredPriceCurrencyCode(objectTypeId, property, homeCurrencyCode, additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.lineItemCurrencyCode);
  }, [objectTypeId, property, additionalValues, homeCurrencyCode]);

  // Disable the button when:
  // - the pricing model is not set
  // - hs_tier_prices or hs_tier_ranges are not set (invalid state for modal)
  // - Object Type is Product
  //    - and both effectiveCurrencyCode and homeCurrencyCode are undefined
  // - Object Type is Line Item
  //    - and effectiveCurrencyCode is undefined (required for TieredPriceModal)
  // There should already be validations on the BE to prevent hs_tier_prices or hs_tier_ranges from being undefined if the pricing model is one of the tiered pricing models.
  const isViewTiersButtonDisabled = (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.pricingModel) == null || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersPrices) == null || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersRanges) == null || objectTypeId === PRODUCT_TYPE_ID && effectiveCurrencyCode === undefined && homeCurrencyCode === undefined || objectTypeId === LINE_ITEM_TYPE_ID && effectiveCurrencyCode === undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      size: "xs",
      use: "tertiary-light",
      onClick: showViewTiersModal,
      "data-test-id": "tiered-price-view-tiers-btn",
      disabled: isViewTiersButtonDisabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.button.viewTiers"
      })
    }), showTiersModal && !isViewTiersButtonDisabled && /*#__PURE__*/_jsx(TieredPriceModal, {
      onSave: onSave,
      onClose: onClose
    })]
  });
};